import React from 'react';
import { ShieldCheckIcon, DollarSignIcon, ZapIcon } from 'lucide-react';
export function TrustSection() {
  return <section id="trust" className="w-full" style={{
    background: '#000000'
  }} data-id="element-544">
      {/* Stats row */}
      <div className="max-w-7xl mx-auto" data-id="element-545">
        <div className="grid grid-cols-2 lg:grid-cols-4" data-id="element-546">
          <div className="flex flex-col items-center justify-center text-center py-16 px-8" style={{
          borderRight: '1px solid rgba(255,255,255,0.08)'
        }} data-id="element-547">
            <div className="font-black leading-none mb-2" style={{
            color: '#FECB00',
            fontSize: 'clamp(3.5rem, 7vw, 5rem)'
          }} data-id="element-548">
              30+
            </div>
            <div className="text-white font-black text-lg sm:text-xl leading-tight mb-1" data-id="element-549">
              Years in Business
            </div>
            <div className="text-sm" style={{
            color: '#616365'
          }} data-id="element-550">
              Serving DMV since 1995
            </div>
          </div>

          <div className="flex flex-col items-center justify-center text-center py-16 px-8" style={{
          borderRight: '1px solid rgba(255,255,255,0.08)'
        }} data-id="element-551">
            <div className="font-black leading-none mb-2" style={{
            color: '#FECB00',
            fontSize: 'clamp(3.5rem, 7vw, 5rem)'
          }} data-id="element-552">
              3
            </div>
            <div className="text-white font-black text-lg sm:text-xl leading-tight mb-1" data-id="element-553">
              DMV Locations
            </div>
            <div className="text-sm" style={{
            color: '#616365'
          }} data-id="element-554">
              Cottage City, Capitol Heights &amp; Suitland
            </div>
          </div>

          <div className="flex flex-col items-center justify-center text-center py-16 px-8" style={{
          borderRight: '1px solid rgba(255,255,255,0.08)'
        }} data-id="element-555">
            <div className="font-black leading-none mb-2" style={{
            color: '#FECB00',
            fontSize: 'clamp(3.5rem, 7vw, 5rem)'
          }} data-id="element-556">
              24/7
            </div>
            <div className="text-white font-black text-lg sm:text-xl leading-tight mb-1" data-id="element-557">
              Always Open
            </div>
            <div className="text-sm" style={{
            color: '#616365'
          }} data-id="element-558">
              Every day, all year round
            </div>
          </div>

          <div className="flex flex-col items-center justify-center text-center py-16 px-8" data-id="element-559">
            <div className="font-black leading-none mb-2" style={{
            color: '#FECB00',
            fontSize: 'clamp(3.5rem, 7vw, 5rem)'
          }} data-id="element-560">
              ∞
            </div>
            <div className="text-white font-black text-lg sm:text-xl leading-tight mb-1" data-id="element-561">
              Free Rotations
            </div>
            <div className="text-sm" style={{
            color: '#616365'
          }} data-id="element-562">
              With every tire purchase
            </div>
          </div>
        </div>
      </div>

      {/* Feature pills strip */}
      <div className="w-full py-10 px-8" style={{
      background: '#111111',
      borderTop: '1px solid rgba(255,255,255,0.06)'
    }} data-id="element-563">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-16" data-id="element-564">
          <div className="flex items-center gap-3" data-id="element-565">
            <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
            background: '#CC0000'
          }} data-id="element-566">
              <ShieldCheckIcon size={18} className="text-white" data-id="element-567" />
            </div>
            <span className="font-bold text-white text-sm" data-id="element-568">
              Certified Technicians
            </span>
          </div>

          <div className="flex items-center gap-3" data-id="element-569">
            <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
            background: '#CC0000'
          }} data-id="element-570">
              <DollarSignIcon size={18} className="text-white" data-id="element-571" />
            </div>
            <span className="font-bold text-white text-sm" data-id="element-572">
              Competitive Pricing
            </span>
          </div>

          <div className="flex items-center gap-3" data-id="element-573">
            <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
            background: '#CC0000'
          }} data-id="element-574">
              <ZapIcon size={18} className="text-white" data-id="element-575" />
            </div>
            <span className="font-bold text-white text-sm" data-id="element-576">Fast Service</span>
          </div>
        </div>
      </div>
    </section>;
}